import React from "react";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import AvatarIcon from "../resources/AvatarIcon";
import { MiniLogo } from "../components/MiniLogo";
import { useTermsAndConditionsStyles } from "../themes/termsAndConditionsStyles";

export const BestWaterAppTermsAndConditionsPage: React.FC = () => {
  const classes = useTermsAndConditionsStyles();
  const history = useHistory();
  const bwtLink = "https://www.bwt.com/";
  const cancellationFile =
    "https://www.bwt.com/de-at/-/media/bwt/at/documents/agb/wr-belehrung-formular.pdf";

  return (
    <div className={classes.pageContainer}>
      <div className={classes.topBar}>
        <Button
          classes={{ root: classes.buttonRoot }}
          onClick={() => {
            history.push("/");
          }}
        >
          <AvatarIcon color="var(--col-navy-500)" />
        </Button>
        <MiniLogo />
      </div>

      <div className={classes.titleContainer}>
        <div>TERMS OF USE & GENERAL TERMS AND CONDITIONS</div>
        <div>BWT BEST WATER APP</div>
        <div>BWT Holding GmbH</div>
      </div>

      <div className={classes.bodyContainer} style={{ gap: "12px" }}>
        <div className={classes.paragraph}>
          BWT Holding GmbH (hereinafter referred to as "BWT") operates the BWT
          Best Water App. Below you will find the Terms of Use and the General
          Terms & Conditions of the BWT Best Water App, which apply to the use
          of the App.
        </div>

        <div className={classes.paragraph}>
          Please read the Terms carefully, as they constitute a binding contract
          between you and BWT.
        </div>

        <div className={classes.subTitle}>
          <b>I. TERMS OF USE BEST WATER APP</b>
        </div>

        <div className={classes.list}>
          <div>
            <b>1. User account:</b> In order to be able to use the services and
            functions of the BWT Best Water App, a user account must be set up.
            This user account is aimed at consumers as defined in point II.1 of
            the following General Terms and Conditions (hereinafter referred to
            as "User"). If the User already has a BWT Best Water App account,
            the user can log in with this account.
          </div>

          <div>
            A user account is personalised for individual users registered by
            name. In this respect, registration must take place before use. The
            user must truthfully complete the required mandatory fields of the
            form. It is not permitted to enter other people's names or addresses
            or a pseudonym. After entering their data in full, the user will
            receive an e-mail with an activation link that is valid for seven
            (7) days from the time the e-mail is sent. By confirming this link,
            the online account is activated. In the event that the user account
            is not confirmed, the user account will be deleted after a further
            seven (7) days. The user will be informed of the deletion by e-mail.
            In this case, the user has the option of registering again and using
            the BWT Best Water App and the user account by entering the access
            data (e-mail address and password).
          </div>

          <div>
            The user is responsible for all activities carried out via their
            user account.
          </div>

          <div>
            The user is responsible for ensuring the confidentiality of the
            access data to his user account, regardless of the device from which
            he accesses it, and he may not disclose information such as user
            name and/or password to other persons. The user must therefore
            comply with all recommended security measures, such as choosing a
            secure password and keeping this password secret under all
            circumstances. If the user has reasonable grounds for concern that
            the access data to his/her user account is being used without
            authorisation, the password for the user account must be changed
            immediately.
          </div>

          <div>
            The user is responsible for ensuring that all personal details,
            billing and delivery addresses and payment methods are always
            up-to-date, correct and complete.
          </div>

          <div>
            This data can be updated at any time via the user account Any change
            to the data in the user account requires renewed consent to the
            General Terms of Use.
          </div>

          <div>
            Users have the option of deleting their user account at any time.
            BWT makes the user account available to users of the BWT Best Water
            App free of charge for an indefinite period but reserves the right
            to take any measures at its own discretion, including the exclusion
            of a user from the programme, if the user in question has violated
            the terms of use or misused the programme in any way. The user will
            be informed of the exclusion from the programme in advance and will
            be given the opportunity to comment before being excluded from the
            programme.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>2. Intellectual property rights:</b> The entire content of the
            BWT Best Water App, including texts, graphics, photos, images,
            moving images, sounds, illustrations and software is the property of
            BWT or its affiliated companies, licensees, licensors and/or content
            providers. This content is protected by copyright and other rights.
            Their use is only permitted with the express written consent of the
            owner or licensor. All trademarks used on the App are - unless
            otherwise stated - trademarks of the vendor and may not be used
            without the prior written consent of the vendor.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>3. Contents:</b> BWT endeavours to keep the information in the
            BWT Best Water App correct and up to date. The liability of BWT, its
            authorised agents or representatives for damages in connection with
            any use of the App as well as the non-fulfilment of an obligation
            that constitutes one of the main performance obligations in the
            contract between BWT and a customer is limited to intent and gross
            negligence, insofar as there is no damage to persons. The liability
            of BWT for financial losses caused by ordinary negligence is
            excluded.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>4. Product description:</b> BWT is not the manufacturer of the
            products and services connected to the BWT Best Water App, unless
            this is expressly stated. Furthermore, BWT provides links to pages
            of affiliated companies and certain other companies, in particular
            the manufacturers of the products and providers of the services.
            This serves as further information for the user. BWT is not
            responsible for these offers or pages.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>5. User data:</b> The data collected is collected and processed
            by BWT for the fulfilment of the contract and in connection with the
            use of the app. In all other respects, reference is made to BWTs
            Best Water App privacy policy.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>6. Electronic communication:</b> BWT will communicate with users
            of the BWT Best Water App electronically in various ways, e.g. via
            e-mail, text messages or push messages, video or telephone
            conference. For contractual purposes, the user agrees that this
            document and all consents, notifications, publications and other
            communications, as well as invoices, are transmitted electronically
            by BWT, insofar as these do not require written form, unless
            mandatory legal regulations or contractual agreements require a
            different form of communication.
          </div>
        </div>

        <div className={classes.subTitle}>
          <b>II. GENERAL TERMS AND CONDITIONS </b>
        </div>

        <div className={classes.list}>
          <b>1. Scope</b>

          <div>
            1.1. These General Terms and Conditions (hereinafter referred to as
            "GTC") apply to the use of the BWT Best Water App.
          </div>

          <div>
            1.2. The BWT Best Water App can be downloaded free of charge to a
            mobile device in the Apple AppStore as well as the Google PlayStore.
            Additional terms of use apply to the use of the BWT online shop,
            which can be accessed&nbsp;
            <a href={bwtLink} target="_blank" rel="noreferrer">
              here
            </a>
            .
          </div>

          <b>2. Description of the App</b>

          <div>
            2.1. The mobile app enables the user to consume specific services
            provided by BWT either locally or by connecting to BWT cloud
            services.
          </div>

          <div>
            2.2. The BWT Best Water App provides Users with insights into their
            various BWT products, including: Control Pool Products (e.g.
            softeners, water dispensers, pool robots), if applicable, Monitor
            product health status, Order consumables (incl. salt, filters etc),
            if applicable. Remote control your product, if applicable, Share
            product with your family or technician.
          </div>

          <div>
            2.3. Users can also receive notifications about their registered
            products, such as water filters, limescale protection systems, water
            dispensers, pool tester kits, and table water filters.
          </div>

          <b>3. Costs</b>

          <div>
            3.1. The registration as well as the use of the App, including its
            Content and Services, are free of charge. BWT reserves the right to
            implement premium features in the future, which can be activated as
            an in-app purchase.
          </div>

          <b>4. Term </b>

          <div>
            4.1. This Agreement shall enter into force upon acceptance of the
            Terms and Conditions of the App and shall terminate upon
            uninstallation of the App by the User.
          </div>

          <b>5. Changes to the GTC and Latest Version </b>

          <div>
            5.1. BWT reserves the right to review and revise the GTC from time
            to time, in particular to satisfy the requirements of providers of
            platforms for the distribution of applications and to reflect
            changes in law or best practice or to deal with additional features
            which we introduce. We will inform the User about any such changes
            by sending the updated version of the GTC (“New GTC”) to the User’s
            email address provided in the registration process. If the User does
            not uninstall the App from the User’s device(s) within a
            one-moth-period after receiving the New GTC and therefore terminate
            this agreement, the New GTC shall apply for the use of the App.
          </div>

          <b>6. Contact</b>

          <div>
            6.1. The User may contact BWT under app@bwt-group.com or +43 6232
            50110 in case the User has any questions, complaints or comments on
            the App, the services or content.
          </div>

          <b>7. License Grant </b>

          <div>
            7.1. BWT grants the User the non-exclusive, non-transferable right,
            limited in time to the duration of the App usage of the User, to use
            the Software for his own purposes, to store and process his data
            within the means of the Software, to load the user interface of the
            Software for display on the screen into the main memory of the end
            devices used for this purpose in accordance with the agreement and
            to make the resulting reproductions of the user interface.
          </div>

          <div>
            7.2. This license grant shall apply accordingly to any updates
            and/or upgrades of the App, the Content and Services provided by
            BWT.
          </div>

          <b>8. User Obligations and Rights </b>

          <div>8.1. The User must:</div>

          <div>
            - not use the App or any Service in any unlawful manner, for any
            unlawful purpose, or in any manner inconsistent with these terms, or
            act fraudulently or maliciously, for example, by hacking into or
            inserting malicious code, such as viruses, or harmful data, into the
            App, any Service or any operating system;
          </div>

          <div>
            - not infringe our intellectual property rights or those of any
            third party in relation to the Users usage of the App or any
            Service, including by the submission of any material (to the extent
            that such use is not licensed by these terms);
          </div>

          <div>
            - not transmit any material that is defamatory, offensive or
            otherwise objectionable in relation to the Users usage of the App or
            any Service;
          </div>

          <div>
            - not use the App or any Service in a way that could damage,
            disable, overburden, impair or compromise our systems or security or
            interfere with other the Users; and
          </div>

          <div>
            - not collect or harvest any information or data from any Service or
            our systems or attempt to decipher any transmissions to or from the
            servers running any Service.
          </div>

          <div>
            8.2. The user is obliged to keep the password chosen during
            registration as well as the other access data secret and to ensure
            that persons authorized by the user to whom access data is made
            available do likewise. BWT will not ask the user for his password at
            any time outside of the software.
          </div>

          <b>9. Breaches and Terminations </b>

          <div>
            9.1. The User has the right to terminate this agreement at any time
            without giving reasons by uninstalling the App from his device(s).
          </div>

          <div>
            9.2. BWT may, in its sole discretion, without prior notice,
            terminate this agreement and therefore the Users Account as well as
            the Users access to this App, including the content or Services
            contained therein, if (i) the User violates clause 8.1 of this GTC
            or (ii) if BWT has notified the User of a breach of any other
            provision of this GTC, has given the User at least 14 days' notice
            to remedy the breach and the User fails to remedy the breach within
            such period.
          </div>

          <b>10. Right of withdrawal </b>

          <div>
            10.1. If the customer is a consumer, he has the right to cancel the
            contract within fourteen days without giving any reason. The
            cancellation period is fourteen days from the day on which the
            customer or a third party named by the customer and not acting as a
            carrier has taken possession of the goods. In order to exercise the
            right of cancellation, the customer must inform BWT by means of a
            clear declaration (e.g. a letter sent by post or e-mail) of the
            decision to cancel this contract. The customer may use the&nbsp;
            <a href={cancellationFile} target="_blank" rel="noreferrer">
              attached sample
            </a>
            &nbsp;cancellation form for this purpose, but this is not mandatory.
          </div>

          <div>
            10.2. No right of cancellation exists or an existing right of
            cancellation expires for:
          </div>

          <div>
            - Goods that are delivered sealed and are not suitable for return
            for reasons of health protection or hygiene, provided that their
            seal has been removed after delivery. This applies in particular to
            water filter cartridges that are secured with a hygiene cap. The
            right of cancellation expires prematurely if the hygiene cap is
            removed.
          </div>

          <div>
            - Goods that have been inseparably mixed with other goods after
            delivery due to their nature.
          </div>

          <div>
            - Goods that are manufactured according to customer specifications
            or are clearly customised to personal requirements.
          </div>

          <div>
            In order to comply with the cancellation period, it is sufficient
            for the customer to send the notification of the exercise of the
            right of cancellation before the expiry of the cancellation period.
          </div>

          <div>
            10.3. The cancellation notice must be sent to the following address:
          </div>
          <div>BWT Sports & Digital Services GmbH</div>
          <div>Walter-Simmer-Str. 4</div>
          <div>5310 Mondsee</div>
          <div>Austria</div>
          <div>E-mail: shop@bwt.com</div>
          <div>T from Austria: 0800 800 555</div>
          <div>T from Germany: 0800 112 22 23</div>

          <div>10.4. Consequences of cancellation:</div>
          <div>
            If the customer cancels this contract, BWT must refund all payments
            received from the customer, including delivery costs (with the
            exception of additional costs resulting from the fact that the
            customer has chosen a type of delivery other than the cheapest
            standard delivery offered by BWT), immediately and at the latest
            within fourteen days from the day on which BWT receives notification
            of the cancellation of this contract. For this repayment, BWT shall
            use the same means of payment that the customer used for the
            original transaction, unless expressly agreed otherwise with BWT; in
            no case shall the customer be charged any fees for this repayment.
            The vendor may refuse to make the repayment until it has received
            the goods back or until the customer has provided proof that he has
            sent the goods back, whichever is the earlier.
          </div>

          <div>
            The customer must return or hand over the goods to BWT immediately
            and in any case no later than fourteen days from the day on which
            the customer informed BWT of the cancellation of the contract in
            question. The deadline is met if the customer dispatches the goods
            before the period of fourteen days has expired.
          </div>

          <div>The vendor shall bear the costs of returning the goods.</div>

          <div>
            The customer shall only be liable for any loss in value of the goods
            if this loss in value is due to handling that is not necessary for
            checking the nature, properties and functioning of the goods.
          </div>

          <b>11. Warranty and compensation </b>

          <div>11.1. The statutory warranty provisions shall apply. </div>

          <div>
            11.2. BWT's liability in the event of intent, gross negligence,
            injury to life, limb or health and in the event of claims under the
            Product Liability Act shall be governed by the statutory provisions.
            In addition, liability for slight negligence is excluded - except in
            the case of injury to life, limb or health.
          </div>

          <div>
            11.3. If damages to the user result from the loss of data, BWT is
            not liable for this, as far as the damages would have been avoided
            by a regular and complete backup of all relevant data by the user.
            The user is responsible to carry out a regular and complete data
            backup by himself or by a third party.
          </div>

          <div>11.4. Availability </div>

          <div>
            BWT provides the user with the software in its current version for
            use at the router exit of the data center in which the server with
            the software is located ("transfer point"). The Software, the
            computing power required for the operation of the Software in the
            data center and the storage and data processing space required for
            this purpose are provided by BWT. However, BWT does not owe the
            establishment and maintenance of the data connection between the IT
            systems of you and the described handover point.
          </div>

          <div>
            BWT does not warrant the continuous availability of the App, any
            Content and Services. Downtimes due to maintenance, software updates
            and due to circumstances (such as technical problems of third
            parties, force majeure) which are not within the BWT’s sphere of
            influence and for which BWT is therefore not responsible and which
            are not accessible via the Internet through the services offered by
            BWT cannot be completely avoided. The User declares not to assert
            any claims for damages and/or warranty claims for failures.
          </div>

          <div>
            BWT reserves the right to remove the App, Content or Services (or
            part thereof) for whatever reason or to interrupt the operation of
            the App, Content or Services (or part thereof) as may be necessary
            to perform routine or non-routine maintenance, error correction or
            other changes.
          </div>

          <div>11.5. Updates </div>

          <div>
            BWT is entitled to further develop and modify the Software, provided
            that such further development or modification (i) is necessary for
            BWT's compliance with mandatory legal requirements, (ii) only means
            an adaptation to the respective proven or current state of the art
            or (iii) does not go beyond what is customary in the trade and
            reasonable for the User in the case of comparable software, i.e.
            does not disappoint the User's legitimate expectation to continue
            using essential functions of the Software that is available.
          </div>

          <div>
            BWT shall provide support and maintenance services for the Software
            according to the applicable consumer protection law.
          </div>

          <div>
            BWT shall keep the software up to date to provide the User with all
            new updates and security patches free of charge. BWT will inform the
            User of the availability of new updates and security patches via the
            email address provided in the registration process. The User is
            obliged to install the updates and security patches immediately
            after they are made available. If the User fails to install an
            update or security patch, proper functioning of the software cannot
            be assured and BWT is not liable for such failure.
          </div>

          <div>
            “Update” means updates of the Software for repairs, enhancements or
            new features applied by BWT to Users devices, including updates to
            the Documentation as a result of such updates
          </div>

          <b>12. Data privacy </b>

          <div>
            The data collected is processed by BWT for the fulfilment of the
            contract and in connection with order processing. In all other
            respects, reference is made to BWT's Best Water App privacy policy.
          </div>

          <b>13. Change of address </b>

          <div>
            The customer undertakes to notify BWT of any changes to his
            residential address and e-mail address as long as the legal
            transaction covered by the contract has not been completely
            fulfilled by both parties. If the notification is omitted,
            declarations shall also be deemed to have been received if they are
            sent to the last known address.
          </div>

          <b>14. Contract language </b>

          <div>
            The languages available to the customer for the conclusion of the
            contract are German and English. The customer can specify the
            desired language of the app by selecting the respective language in
            the user account settings of the BWT Online Shop.
          </div>

          <b>15. Imprint/operator of the App </b>

          <div>Operator of the BWT Best Water App</div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridTemplateRows: "repeat(6, 1fr)",
              gridAutoFlow: "column",
              columnGap: "8px",
            }}
          >
            <div>
              <b>BWT Holding GmbH</b>
            </div>
            <div>Walter-Simmer-Str. 4</div>
            <div>5310 Mondsee</div>
            <div>Austria</div>
            <div>E-Mail: app@bwt.com </div>
            <div>T.: +43 6232 50110</div>
            <div style={{ gridRow: "2" }}>
              Company register number: FN 96162 s
            </div>
            <div>Commercial register court: Landesgericht Wels</div>
            <div>UID Nr.: ATU23473603</div>
            <div>Regulatory authority: BH Vöcklabruck</div>
            <div>Member of the Austrian Economic Chamber</div>
          </div>

          <b>16. Applicable law, jurisdiction and dispute resolution </b>

          <div>
            16.1. Austrian law shall apply to the exclusion of national conflict
            of laws provisions and to the exclusion of the UN Convention on
            Contracts for the International Sale of Goods. This choice of law
            shall only apply insofar as the customer as a consumer is not
            deprived of the protection afforded to him by the mandatory
            provisions of the law of the country in which he has his habitual
            residence.
          </div>

          <div>
            16.2. An action by the customer against BWT may be brought either
            before the courts of the Member State in whose territory BWT has its
            registered office or before the court of the place where the
            customer is domiciled. An action brought by BWT against the customer
            may only be brought before the courts of the Member State in whose
            territory the customer is domiciled.
          </div>

          <div>
            16.3. The European Commission provides a platform for online dispute
            resolution (OS), which can be accessed via the following link:
            https://ec.europa.eu/consumers/odr/. There is no obligation to
            participate in a dispute resolution procedure before a consumer
            arbitration board. Furthermore, BWT is not willing to participate in
            such a dispute resolution procedure.
          </div>
        </div>
      </div>
    </div>
  );
};
